// Copyright 2026 Hardfin, Inc.
import { PageContent } from '@/components/page-content';
import { movementStatusSchema } from '@/movement/api/types';
import { MovementListing } from '@/movement/components/movement-listing';
import {
  MovementSearchListing,
  movementSearchListingSchema,
} from '@/movement/hooks/use-movements';
import { createFileRoute } from '@tanstack/react-router';

const movementsSearchSchema = movementSearchListingSchema.extend({
  status: movementStatusSchema.default('all').catch('all'),
});

export const Route = createFileRoute('/_app/movements/')({
  component: MovementsRoute,
  validateSearch: movementsSearchSchema,
});

function MovementsRoute() {
  const navigate = Route.useNavigate();
  const search = Route.useSearch();
  const currentStatus = search.status;
  const searchParameters: MovementSearchListing = {
    page: search.page,
    query: search.query,
    status: currentStatus === 'all' ? undefined : currentStatus,
    itemIds: search.itemIds,
    originIds: search.originIds,
    destinationIds: search.destinationIds,
    hasShipment: search.hasShipment,
  };

  return (
    <PageContent>
      <MovementListing
        currentStatus={currentStatus}
        searchParameters={searchParameters}
        navigateFn={navigate}
      />
    </PageContent>
  );
}
